import { DateUtils } from "utils";

import { ContractDetails } from "./types";

export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return "";
  const date = parseContractDate(dateStr);
  if (!date) return "";
  return DateUtils.formatDateDisplay(date);
};

export const parseContractDate = (dateStr?: string): Date | null => {
  if (!dateStr) return null;

  const [yearString = "", monthString = "", dayString = ""] = dateStr.split("T")[0]?.split("-") || [];
  const year = Number(yearString);
  const month = Number(monthString);
  const day = Number(dayString);

  if (year && month && day) {
    return new Date(year, month - 1, day);
  }

  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date;
};

export const formatContractDateForApi = (value: Date | null): string | undefined => {
  if (!value) return undefined;

  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const isContractActive = (contract: ContractDetails) => !!(contract.active || contract.info?.active);

export const pickActiveContract = (
  data: ContractDetails | ContractDetails[] | undefined,
): { contract?: ContractDetails; previousContract?: ContractDetails } => {
  if (!data) return {};

  const contracts = Array.isArray(data) ? data : [data];

  const sortedContracts = [...contracts].sort(
    (a, b) =>
      new Date(b.info?.createdAt || 0).getTime() - new Date(a.info?.createdAt || 0).getTime()
  );

  const contract = sortedContracts.find(isContractActive) ?? sortedContracts[0];

  const previousContract = (
    contract?.parentContractId
      ? sortedContracts.find((item) => item.id === contract.parentContractId)
      : undefined
  ) ?? sortedContracts.find((item) => item.id !== contract?.id && !isContractActive(item));

  return { contract, previousContract };
};
